import {useLoginStore} from '@store/LoginStore'
import {useRouter} from 'next/router'
import {useEffect, useState} from 'react'
import {FILTER_LOGIN_BROWSER} from '@constant/auth'

const useLogin = (userID?: string) => {
    const id = useLoginStore(state => state.id)
    const router = useRouter()

    const [isMe, setIsMe] = useState(undefined)

    useEffect(() => {
        setIsMe(userID && id === userID)
    }, [userID, id])

    const isLogin = () => {
        return id && id.length > 0
    }

    const checkLoginRedirect = () => {
        if (!isLogin()) {
            router.push('/login')
            return true
        }

        return false
    }

    const checkUserBrowser = () => {
        if (
            typeof window !== 'undefined' &&
            FILTER_LOGIN_BROWSER?.filter(i => window?.navigator?.userAgent?.includes(i))?.length > 0
        )
            return false
        return true
    }

    return {id, isLogin, isMe, checkLoginRedirect, checkUserBrowser}
}

export default useLogin
